__turbopack_context__.v({
  "btnStyle": "section-module-scss-module__jwC-7a__btnStyle",
  "error": "section-module-scss-module__jwC-7a__error",
  "section_btn": "section-module-scss-module__jwC-7a__section_btn",
  "section_content": "section-module-scss-module__jwC-7a__section_content",
  "section_contents": "section-module-scss-module__jwC-7a__section_contents",
  "section_line": "section-module-scss-module__jwC-7a__section_line",
  "section_terms": "section-module-scss-module__jwC-7a__section_terms",
  "section_title": "section-module-scss-module__jwC-7a__section_title",
  "section_titles": "section-module-scss-module__jwC-7a__section_titles",
  "switchBox": "section-module-scss-module__jwC-7a__switchBox",
  "terms_desc": "section-module-scss-module__jwC-7a__terms_desc",
  "terms_desc__cmortgage": "section-module-scss-module__jwC-7a__terms_desc__cmortgage",
  "terms_details_block": "section-module-scss-module__jwC-7a__terms_details_block",
  "terms_details_btn": "section-module-scss-module__jwC-7a__terms_details_btn",
  "terms_line": "section-module-scss-module__jwC-7a__terms_line",
  "terms_list": "section-module-scss-module__jwC-7a__terms_list",
  "terms_title": "section-module-scss-module__jwC-7a__terms_title",
});
